<!--
  Разделитель даты в ленте сообщений чата.
-->
<template>
  <div
    class="chat-date-separator"
    role="button"
    tabindex="0"
    :aria-expanded="expanded"
    @click="toggleExpanded"
    @keydown.enter.prevent="toggleExpanded"
    @keydown.space.prevent="toggleExpanded"
  >
    <span class="chat-date-separator__label">{{ displayedLabel }}</span>
  </div>
</template>

<script>
export default {
  name: "ChatDateSeparator",

  props: {
    label: {
      type: String,
      required: true,
    },
    dateKey: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      expanded: false,
    };
  },

  computed: {
    displayedLabel() {
      if (this.expanded || !this.compactLabel) {
        return this.fullLabel;
      }

      return this.label;
    },

    compactLabel() {
      return ["Сегодня", "Вчера", "Завтра"].includes(this.label);
    },

    fullLabel() {
      const date = new Date(`${this.dateKey}T00:00:00`);
      if (Number.isNaN(date.getTime())) return this.label;

      const formattedDate = date.toLocaleDateString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      const weekday = date.toLocaleDateString("ru-RU", {
        weekday: "long",
      });

      return `${formattedDate}, ${weekday}`;
    },
  },

  watch: {
    dateKey() {
      this.expanded = false;
    },
  },

  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style scoped>
.chat-date-separator {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 4px 0;
  cursor: pointer;
}

.chat-date-separator:focus-visible {
  outline: 2px solid var(--color-green);
  outline-offset: 2px;
}

.chat-date-separator__label {
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.82);
  color: #777;
  font-size: 11px;
  line-height: 1.2;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  white-space: nowrap;
}
</style>
